import {HasUUID} from '../has-uuid';
import {Uuid} from '../uuid';
import {RikData} from '../rik-data';
import {Location} from '../location/location';

export class MyWorkshop implements HasUUID {
  uuid: Uuid;
  name: string;
  description: string;
  phone: string;
  email: string;
  opens_at: string;
  arrive_before: string;
  arrive_before_close_day_before: string;
  afternoon_arrival_time: string;
  morning_departure_time: string;
  closes_at: string;
  closes_at_day_before: string;
  location: Location;

  constructor(data: any) {
    const rikData = new RikData(data);
    this.uuid = rikData.requireExists('uuid');
    this.name = rikData.requireExists('name');
    this.description = rikData.requireExists('description');
    this.phone = rikData.requireExists('phone');
    this.email = rikData.requireExists('email');
    this.opens_at = rikData.requireExists('opens_at');
    this.arrive_before = rikData.requireExists('arrive_before');
    this.arrive_before_close_day_before = rikData.requireExists('arrive_before_close_day_before');
    this.afternoon_arrival_time = rikData.requireExists('afternoon_arrival_time');
    this.morning_departure_time = rikData.requireExists('morning_departure_time');
    this.closes_at = rikData.requireExists('closes_at');
    this.closes_at_day_before = rikData.requireExists('closes_at');
    this.location = rikData.requireObject('location', Location);
  }
}
